export default {"src":"/_next/static/media/tangerine.bbcf164a.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};